<template>
  <nav class="sidebar-menu">
    <template v-for="(item, index) in nav_item">
      <template v-if="item.children">
        <nav-group-item
          :key="index"
          :item="item"
          :is_opened="current_open === item.name"
          @open="set_open"
        />
      </template>
      <template v-else>
        <nav-item
          :key="index"
          :item="item"
          :current_open="current_open"
          @click.native="collapse_all"
        />
      </template>
    </template>
  </nav>
</template>

<script>
  import NavItem from './nav-item';
  import NavGroupItem from './nav-group-item';
  import items from './_nav-items';
  import { is_allow_route } from '@shared/helpers/permissions';
  import { mapGetters } from 'vuex';

  export default {
    components: { NavItem, NavGroupItem },
    data: () => ({
      current_open: ''
    }),
    computed: {
      ...mapGetters('core/auth', ['user']),
      nav_item() {
        return items
          .map((item) => {
            /**
             * Если есть подпункты - проверяем, нужно ли их скрыть
             */
            if (item.children) {
              item.children = item.children.filter((child) => this.is_visible(child));
            }
            return item;
          })
          .filter((item) => this.is_visible(item));
      }
    },
    watch: {
      $route: {
        handler: function () {
          this.current_open = '';
        },
        immediate: true
      }
    },
    methods: {
      is_visible(item) {
        try {
          if (item.route && item.route.name) {
            const resolve = this.$router.resolve(item.route);
            return is_allow_route(resolve.route, this.$permission, this.$config);
          }

          return true;
        } catch (e) {
          console.error(e);
          return false;
        }
      },
      set_open(name) {
        if (this.current_open === name) {
          this.current_open = '';
        } else {
          this.current_open = name;
        }
      },
      collapse_all() {
        this.current_open = '';
      }
    }
  };
</script>

<style lang="scss">
  .sidebar-menu {
    list-style-type: none;
    padding: 0;
    font-size: 15px;
    color: $header-color;

    &__item {
      margin-bottom: 10px;
    }

    &__item-icon {
      margin-right: 10px;
    }

    &__item-link {
      align-items: center;
      background-repeat: no-repeat;
      color: $header-color;
      display: flex;
      flex: 1;
      font-size: 16px;
      letter-spacing: 0.3px;
      padding-bottom: 13px;
      padding-left: 30px;
      padding-top: 13px;
      position: relative;
      &:hover,
      &.exact-active {
        color: $blue;
        background-color: $grey;
        text-decoration: none;
      }
    }

    // hover for icon
    &__item-link:hover &__item-icon {
      filter: brightness(0.4) saturate(89.7) hue-rotate(-6deg);
    }
    // active for icon
    &__item--active &__item-icon {
      filter: brightness(0.4) saturate(89.7) hue-rotate(-6deg);
    }

    // active item link
    &__item--active &__item-link {
      color: $blue;
      background-color: $grey;
      border-right: 2px solid $blue;
    }

    // arrow
    &__item--sub &__item-link:after {
      transition: all 0.3s;
      transform: rotate(-90deg);
      font-family: Ionicons;
      content: '\F116';
      position: absolute;
      right: 15px;
      top: 13px;
    }
    // active arrow
    &__item--sub,
    &__item--active &__item-link:after {
      transform: rotate(0deg);
    }

    &__sub-link {
      display: block;
      letter-spacing: 0.3px;
      color: $header-color;
      font-size: 14px;
      padding-top: 9px;
      padding-bottom: 9px;
      padding-left: 75px;
      &:hover,
      &.exact-active,
      &--active {
        color: $blue;
        background-color: $grey;
        text-decoration: none;
      }
    }
  }
</style>